module.exports = "# Esmeralda and Goober Story\n\nYouTube: i6c_oeWPDxg\n\n## Notes\nEsmeralda and Goober storyline - Make a Plan (1:47).\n\n# Calming Breath Intro\n\nYouTube: bDy55oVYj00\n\n## Notes\nSara and Ian help Apprentices practice the Superhero Calming Breath (0:49).\n"


//////////////////
// WEBPACK FOOTER
// ./programs/epsHybridIntermediates/sections/11_esGooberStory/level1_egstory.md
// module id = 1541
// module chunks = 2